import { Container, Jumbo, Skeleton } from '@treams/treams-ui';
import { t } from 'i18next';
import UserCard from './UserCard';
import type { DevelopmentPlanUserFragment } from 'generated/graphql';
import Goal from './Goal';
import styled from 'styled-components';
import Goals from './Goals';

const Content = styled(Container)`
	margin-bottom: 40px;
`;

export default Skeleton(
	function DevelopmentPlan({
		user,
		onSave,
	}: {
		user: DevelopmentPlanUserFragment;
		onSave: () => void;
	}) {
		return (
			<>
				<Jumbo title={t('developmentPlan.index.title')}>
					<UserCard user={user} />
				</Jumbo>
				<Content>
					<Goals onSave={onSave} user={user} />
				</Content>
			</>
		);
	},
	function DevelopmentPathSkeleton() {
		return (
			<>
				<Jumbo.Skeleton>
					<UserCard.Skeleton />
				</Jumbo.Skeleton>
				<Content>
					<Skeleton.Repeat count={3}>
						<Goal.Skeleton />
					</Skeleton.Repeat>
				</Content>
			</>
		);
	},
);
